export default __webpack_public_path__ + "static/media/my-claims.e3b59f43.svg";